import { render, staticRenderFns } from "./ArticleTeaser.vue?vue&type=template&id=b4d0d4ce&scoped=true&"
import script from "./ArticleTeaser.vue?vue&type=script&lang=js&"
export * from "./ArticleTeaser.vue?vue&type=script&lang=js&"
import style0 from "./ArticleTeaser.vue?vue&type=style&index=0&id=b4d0d4ce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4d0d4ce",
  null
  
)

export default component.exports